import * as React from 'react'

import { connect } from 'react-redux'

import { communicationToLoadableProps } from '../../project-utils'
import {
  ApplicationState,
  personalInformationEditRequest,
  personalInformationGetRequest,
  selectPersonalInformation,
}                                       from '../../redux'
import EditPersonalForm                 from '../forms/PersonalInformationEditForm'

const mstp = (state: ApplicationState) =>
  ({
    personalInformationGetCommunication:  personalInformationGetRequest.communicationSelector(state),
    personalInformationEditCommunication: personalInformationEditRequest.communicationSelector(state),
    personalInformation:                  selectPersonalInformation(state),
  })

const actions = {
  getPersonalInformation:  personalInformationGetRequest.actionCreator,
  editPersonalInformation: personalInformationEditRequest.actionCreator,
}

type EditPersonalInformationProps =
  ReturnType<typeof mstp>
  & typeof actions

class EditPersonalInformation extends React.Component<EditPersonalInformationProps> {
  public componentDidMount () {
    this.props.getPersonalInformation()
  }

  public render () {
    const {
      editPersonalInformation,
      personalInformationGetCommunication,
      personalInformationEditCommunication,
      personalInformation,
    } = this.props

    return (
      <EditPersonalForm
        isCached={personalInformation}
        values={personalInformation}
        onSubmit={editPersonalInformation}
        {...communicationToLoadableProps(personalInformationGetCommunication)}
        {...personalInformationEditCommunication}
      />
    )
  }
}

export default connect(
  mstp,
  actions,
)(EditPersonalInformation)



// WEBPACK FOOTER //
// ./src/components/environments/EditPersonalInformation.tsx